module.exports = ".contenido{\n    min-height: 100vh;\n}\n\n.fondoNegro{\n    background-color: #273135 !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./app/cambiarPassword/cambiarPassword.component.css
// module id = 1013
// module chunks = 0